export const handleNavigationTobackOffice = () => {
  if (process.env.REACT_APP_PLAYEREND_FRONTEND) {
    localStorage.clear();
    return (window.location.href = process.env.REACT_APP_PLAYEREND_FRONTEND);
  }
};
